module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/application-settings/application-setting/application-setting.component.scss
// module id = ./src/app/components/framework/application-settings/application-setting/application-setting.component.scss
// module chunks = main